module.exports = __webpack_public_path__ + "img/slider5.38ce2764.png";